import { DEAL_LABELS } from "./common";

export const FEATURES_NAME = {
  // DASHBOARD_FEATURES
  DASHBOARD_DISMISS_DUMMY: "dashboard.dismiss_dummy",

  // DOCUMENT_FEATURE
  DOCUMENTS_EXPORT_TO_DOCX: "documents.export_to_docx",
  DOCUMENTS_THIRD_PARTY_UPLOAD: "documents.third_party_upload",
  ESIGN_SIGNATURES: "documents.esign",

  // PIPELINE_FEATURES
  PIPELINE_CREATE_DOCUMENT: "pipeline.create_document",
  PIPELINE_CREATE_OPPORTUNITY: "pipeline.create_opportunity",

  // PRICEBOOK_FEATURES
  PRICEBOOK_ADD_COLUMN: "pricebook.add_column",
  PRICEBOOK_ADD_PRICEBOOK: "quoting.pricebook",
  PRICEBOOK_CLAUSE_ASSOCIATION: "pricebook.clause_association",
  PRICEBOOK_DEAL_PROPERTISE: "pricebook.deal_propertise",
  PRICEBOOK_TOGGLE_STATUS: "pricebook.toggle_status",
  QUOTING_DIY_PRICING: "quoting.diy_pricing",
  QUOTING_BUNDLE_PRICING: "quoting.bundle_pricing",
  QUOTING_BUNDLE_PRODUCT: "quoting.bundle_product",

  // PRODUCT_FEATURES
  PRODUCT_ADD_PRODUCT: "product.add_product",
  PRODUCT_MODIFY_PRODUCT: "product.modify_product",
  PRODUCT_HIDDEN: "quoting.product_catalog",

  // TEMPLATES_FEATURES
  DOCUMENTS_CONTENT_LOCKING: "documents.content_locking",
  TEMPLATES_ADD_CLAUSE_LIST: "templates.add_clause_list",
  TEMPLATES_CLAUSE_OPTIONS: "templates.clause_options",
  TEMPLATES_IMAGE_FIELD: "templates.image_field",
  TEMPLATES_CUSTOM_VARIABLES: "templates.custom_variables",
  TEMPLATES_WORKFLOW_DF: "templates.workflow_df",

  // WORKFLOW_FEATURES
  WORKFLOW_CREATE_NEW: "wf.dt_workflow",
  WORKFLOW_PRICEBOOK_LEVEL: "workflow.pricebook_level",
  WORKFLOW_SKU_LEVEL: "workflow.sku_level",
  WF_CLAUSE_OPTIONS: "wf.clause_options",
  WF_STANDARD_VARIABLES: "wf.standard_variables",

  // CRM INTEGRATIONS
  INTG_SALESFORCE_STANDARD: "intg.salesforce_standard",
  INTG_ZOHO: "intg.zoho",

  // Zapier Integrtions
  INTG_ZAPIER: "intg.zapier",

  // Stripe Integration
  INTG_STRIPE: "intg.stripe",

  // SYSTEM
  SYSTEM_CUSTOM_ROLES: "system.custom_roles",
  SYSTEM_USER_MANAGEMENT: "system.user_management",
  SYSTEM_SSO: "system.sso",
};

export const FEATURES_DISPLAY_NAME = {
  ADD_TO_CLAUSE_LIST: "Dynamic Clauses and Workflow Rules",
  ADDING_PRICEBOOKS: "Multiple Price Book Advantage",
  WORKFLOW_ON_DF: "Workflow Rules on Form Fields",
  WORKFLOWS: "Workflows",
};

// these descriptions are currently being shown on TnB unlock popups
// export const FEATURES_DESCRIPTIONS = {
//   ADD_TO_CLAUSE_LIST:
//     "If you want to spend less time building contracts, and amending your clauses and allow more time in selling and engaging with your customers, start using this feature. It improves the accuracy and consistency of your documents and makes sure that your contract approval process remains compliant.",
//   ADDING_PRICEBOOKS:
//     "Take the advantage of price book flexibility and add as many as price books in various currencies, for different geographies, or any other variations based on your organization's needs.",
//   WORKFLOW_ON_DF:
//     "Get started with this feature to capture data that is important for your business quickly by auto-filling form fields. Furthermore, you can automate approval workflows on form fields to avoid usage of unauthorized terms/conditions.",
//   WORKFLOWS:
//     "Eliminate bottlenecks in your deal approval process! Speed up and streamline your process with Revv multi-level workflows. It’s time to say ‘bye’ to unauthorized document changes, pricing anomalies, and delays in approvals. Upgrade to get complete control over your deals.",
//   DESCRIPTION:
//     "Our solution expert will walk you through this feature, so you could unlock the value",
// };

export const PRO_FEATURES_DESCRIPTION =
  "Our solution expert will walk you through this feature, so you could unlock the value";

export const UPGRADE_TEXT = {
  [FEATURES_NAME.ESIGN_SIGNATURES]: {
    displayName: "e-Signature",
    welcomeMsg: "Great! Looks like your business is growing!",
    upsaleMsg:
      "Upgrade to a higher plan for sending more documents for signature and using many more impressive features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
    counterData: {
      title: "E-signs consumed",
    },
  },
  [FEATURES_NAME.SYSTEM_USER_MANAGEMENT]: {
    displayName: "User management",
    welcomeMsg: "Great!Looks like your team is growing!",
    upsaleMsg:
      "Upgrade to a higher plan for adding more users to your account and experience amazing features!",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
    counterData: {
      title: "Users consumed",
    },
  },
  [FEATURES_NAME.SYSTEM_SSO]: {
    displayName: "SSO",
    welcomeMsg: "Want to benefit from Revv SSO feature for improved security?",
    upsaleMsg:
      "Upgrade to a higher plan to get SSO and many more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.DOCUMENTS_EXPORT_TO_DOCX]: {
    displayName: "Export to MS Word (.docx)",
    welcomeMsg: "Elevate your Revv experience with more features like these!",
    upsaleMsg:
      "Upgrade to a higher plan to start using the export feature and more.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.WF_CLAUSE_OPTIONS]: {
    displayName: "Conditional Workflows (Clause Options)",
    welcomeMsg:
      "Elevate your Revv experience with workflow based on clause options!",
    upsaleMsg:
      "Upgrade to a higher plan to start using workflows and more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.DOCUMENTS_CONTENT_LOCKING]: {
    displayName: "Content locking",
    welcomeMsg: "You need to upgrade to get the content locking feature!",
    upsaleMsg:
      "Upgrade to a higher plan for using content lock and much more features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.TEMPLATES_CUSTOM_VARIABLES]: {
    displayName: "Custom variables in templates",
    welcomeMsg:
      "Wow! Want to empower your team with custom variable flexibility in templates?",
    upsaleMsg:
      "Upgrade to a higher plan for using variables and much more features!",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS]: {
    displayName: "Clause options in templates",
    welcomeMsg: "Great! You discovered a premium feature.",
    upsaleMsg:
      "Upgrade to a higher plan for using clause options and many other impressive features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.TEMPLATES_IMAGE_FIELD]: {
    displayName: "Image form field in templates",
    welcomeMsg: "Great! You discovered a premium feature.",
    upsaleMsg:
      "Upgrade to a higher plan for using image form field and many other impressive features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.WORKFLOW_CREATE_NEW]: {
    displayName: `${DEAL_LABELS["deal-table-label"]} Workflow`,
    welcomeMsg: `It looks like you are interested in our ${DEAL_LABELS[
      "deal-table-label"
    ].toLocaleLowerCase()} based workflow feature!`,
    upsaleMsg:
      "Upgrade to a higher plan to start using workflows and more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.QUOTING_DIY_PRICING]: {
    displayName: "On Demand Pricing (DIY Pricing)",
    welcomeMsg:
      "Are you looking for more flexibility in the quote/pricing table?",
    upsaleMsg:
      "Upgrade to a higher plan for benefiting from more features like DIY pricing.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.QUOTING_BUNDLE_PRICING]: {
    displayName: "Bundle Pricing",
    welcomeMsg:
      "Would you like to benefit from more features like Bundle pricing?",
    upsaleMsg:
      "Upgrade to a higher plan for bundle price and many other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.INTG_SALESFORCE_STANDARD]: {
    displayName: "Salesforce Standard",
    welcomeMsg:
      "You need to upgrade to a higher plan for integrating Revv with Salesforce!",
    upsaleMsg:
      "Upgrade to a higher plan for integration with Salesforce and many more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.INTG_ZOHO]: {
    displayName: "Zoho",
    welcomeMsg:
      "You need to upgrade to a higher plan for integrating Revv with Zoho!",
    upsaleMsg:
      "Upgrade to a higher plan for integration with Zoho and many more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.SYSTEM_CUSTOM_ROLES]: {
    displayName: "Custom roles",
    welcomeMsg: "It looks like you are interested in the custom role feature!",
    upsaleMsg:
      "Upgrade to a higher plan for benefiting from Revv custom role and many other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.DOCUMENTS_THIRD_PARTY_UPLOAD]: {
    displayName: "Third-party paper upload",
    welcomeMsg: "Want to benefit from more features like this?",
    upsaleMsg:
      "Upgrade to a higher plan for using import third party documents feature and much more!",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.PRICEBOOK_ADD_PRICEBOOK]: {
    displayName: "Pricebook",
    welcomeMsg:
      "You need to upgrade your plan to get unlimited price books feature!",
    upsaleMsg:
      "Upgrade to a higher plan for benefiting from unlimited price books and other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
  [FEATURES_NAME.WF_STANDARD_VARIABLES]: {
    displayName: "Conditional Workflows (Custom Variables)",
    welcomeMsg:
      "Would you like to benefit from more features like custom fields based workflows?",
    upsaleMsg:
      "Upgrade to a higher plan to start using workflows and more awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
    counterData: {
      title: "Workflow Consumed",
    },
  },
  [FEATURES_NAME.QUOTING_BUNDLE_PRODUCT]: {
    displayName: "Product - Bundle",
    welcomeMsg:
      "Are you looking for more flexibility in product catalog and pricing with features like bundle products?",
    upsaleMsg:
      "Upgrade to a higher plan for bundle product pricing and many other awesome features.",
    features: [
      "Dashboard insights",
      "Customizable templates",
      "Unlimited documents",
      "Collaboration and negotiation capabilities",
      "Premium support",
    ],
  },
};



// WEBPACK FOOTER //
// ./src/constants/features.js